import { render, staticRenderFns } from "./q-img-rasterized.vue?vue&type=template&id=4095bbfc&"
import script from "./q-img-rasterized.vue?vue&type=script&lang=js&"
export * from "./q-img-rasterized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg});
